export default __webpack_public_path__ + "8b4f4a09de701572cd5d11e04f2cd227.svg";